import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/.jenkins/workspace/47.102.216.211-loffice-frontend-dev/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var env = process.env.NODE_ENV;
var envMap = {
  production: {
    APPID: 'wx66afc8a899dcb3ab',
    redirectUri: 'https://loffice.shlp.com',
    groupProjectId: 29,
    groupLesseeId: 279,
    sjjrgcPid: 41,
    sjddhPid: 36,
    sjddh4Bid: 14,
    senselessthrocolleId: 179,
    vipParkGroupId: 201,
    ZJPrjId: 50,
    XTPrjId: 52
  },
  local: {
    APPID: 'wxa57d35c092b592a8',
    redirectUri: 'https://dev.ljzloffice.com',
    groupProjectId: 29,
    groupLesseeId: 279,
    sjjrgcPid: 46,
    sjddhPid: 44,
    sjddh4Bid: 93,
    senselessthrocolleId: 176,
    vipParkGroupId: 180,
    ZJPrjId: 101,
    XTPrjId: 107
  },
  development: {
    APPID: 'wxa57d35c092b592a8',
    redirectUri: 'https://dev.ljzloffice.com',
    groupProjectId: 29,
    groupLesseeId: 279,
    sjjrgcPid: 46,
    sjddhPid: 44,
    sjddh4Bid: 93,
    senselessthrocolleId: 176,
    vipParkGroupId: 180,
    ZJPrjId: 101,
    XTPrjId: 107
  },
  alphaser: {
    APPID: 'wxa57d35c092b592a8',
    redirectUri: 'https://dev.ljzloffice.com',
    groupProjectId: 29,
    groupLesseeId: 279,
    sjjrgcPid: 41,
    sjddhPid: 44,
    sjddh4Bid: 93,
    senselessthrocolleId: 179,
    vipParkGroupId: 180,
    ZJPrjId: 101,
    XTPrjId: 107
  }
};
export default _objectSpread({}, envMap[env]);